module.exports = __webpack_public_path__ + "static/media/Punjab Public Library 1920.5005aff7.jpeg";